import { useArtists } from "../../hooks/useArtists";
import Error from "./error";
import { Artist } from "../../models/artist";

interface ArtistSelectorProps {
  selected?: Artist;
  onChange: (changed: Artist) => void;
}

export function ArtistSelector({
  selected,
  onChange,
}: Readonly<ArtistSelectorProps>) {
  const { isLoading, artists, isError, error } = useArtists();

  if (isLoading) {
    return <div className={"loading loading-ring loading-xs"}></div>;
  }

  if (isError) {
    console.log(error);
    return <Error />;
  }
  if (!isLoading && artists && artists.length > 0) {
    return (
      <select
        className={`select select-ghost select-sm max-w-48 bg-primary text-primary-content text-wrap ${selected && selected.name.length > 13 ? "text-[0.7rem]/3" : ""}`}
        onChange={(e) => {
          const selectedArtist = artists?.find(
            (artist) => artist.id === Number(e.target.value),
          );
          if (selectedArtist) {
            onChange(selectedArtist);
          }
        }}
        value={selected?.id}
      >
        {isLoading ? (
          <option selected disabled>
            ...
          </option>
        ) : (
          artists?.map((artist) => (
            <option key={artist.id} value={artist.id}>
              {artist.name || artist.code}
            </option>
          ))
        )}
      </select>
    );
  } else {
    return <></>;
  }
}
